import { GenericCollectionFactory } from "../_generics";
import { GENERIC_IDS } from "../_constants/generics.constants";

export const PendingInvitationsStore = GenericCollectionFactory(GENERIC_IDS.PENDING_INVITATIONS, "uid");